import React, { FC, useEffect, useState } from "react";
import { Meter } from "../../../interfaces/Meter";
import DataTable from 'react-data-table-component';
import { CSVLink } from "react-csv";
import { IonButton, IonRow} from "@ionic/react";
import usePermissionGroups from "../../../utils/usePermissionGroups";
import NotificationPopUp from "../../extras/NotificationPopUp";
import { API_URL } from "../../../actions/settings";
import ConfirmDeleteBtnModal from "../Modals/ConfirmDeleteBtnModal";
import useToggle from "../../../utils/useToggle";


interface MeterDataRow {
  uuid: string;
  meter: Meter;
  value: number;
  units: string;
  adjusted_value: string | number;
  date: string | Date;
  hour: string | number;
}

interface IProps {
    id:any;
}

async function getData(token: string, url: string) {
  return fetch(`${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Could not fetch data")
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Could not fetch data")
      });
}

async function deleteItem(token:any,data:any) {

    return fetch(`${API_URL}/interval_data/model/delete`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify(data)

    })
      .then(data => data.json())
   }


const ModelIntervalDataTable:FC<IProps> = (props) => {
    const url = new URL (`${API_URL}/interval_data/model/${props.id}?page=1`) 
    const { hasPermission } = usePermissionGroups()    
    const [tableData, setTableData] = useState([])
    const [meter, setMeter] = useState<any>(null)
    const [count, setCount] = useState(0)
    const [selected, setSelected] = useState([])
    const [clearRows, toggleClearRows] = useToggle(false)


    useEffect(()=>{

        const handleData = async () => {
            const token = localStorage.getItem('token') || ""
        const res = await getData(`Token ${token.slice(1,-1)}`, `${API_URL}/interval_data/model/${props.id}?page=1`)
        if (res) {
            setTableData(res.results.data)
            setCount(res.count)
            setMeter(res.results.meter_data)
        }
        }
        handleData()
        
    },[props.id])

    const handleFilterData = async () => {
        const token = localStorage.getItem('token') || ""
        const res = await getData(`Token ${token.slice(1,-1)}`, url.toString())        
        if (res) {
            setTableData(res.results.data)
        }
    }



    const handleDelete = async (id:any) =>{
        const token = localStorage.getItem('token') || ""        
        if (id === 'all'){
            const data = {
                'meter_id': props.id
            }
            const res = await deleteItem(`Token ${token.slice(1,-1)}`,data)
            if (res.status === "success"){
                NotificationPopUp('success','All Interval Model Data Deleted')
                setTableData(
                    []
                )
                setCount(0)
                setSelected([])
                toggleClearRows()

            }
            else{
                NotificationPopUp('error',res.detail,res.error||"Could Not Delete")
            }
        }
        else if (id && id !== ''){
            const data = {
                'ids': id
            }
            const res = await deleteItem(`Token ${token.slice(1,-1)}`,data)
            if (res.status === "success"){
                NotificationPopUp('success','Interval Model Data Deleted')
                setTableData(
                    (prevState:any) => prevState.filter((bill:any) => !id.includes(bill.uuid))
                )
                setCount((prev:number)=>prev-selected.length)
                setSelected([])
                toggleClearRows()

            }
            else{
                NotificationPopUp('error',res.detail,res.error||"Could Not Delete")
            }
        }
    }

    const handleSelect = (e:any) => {
        setSelected(e.selectedRows.map((row:MeterDataRow) => row.uuid))
    }

    const columns = [
    {
        name: "Date",
        selector: (row: MeterDataRow) => new Date(row.date).toLocaleDateString(),
        sortable: true,
    },
    {
        name:"Hour",
        selector: (row:MeterDataRow)=>row.hour,
        sortable:false
    },
    {
        name:"Value",
        selector: (row: MeterDataRow) => row.value,
        sortable: false,
    },
    {
        name:"Adjusted Value",
        selector: (row: MeterDataRow) => row.adjusted_value,
        sortable: false,
    },
    {
        name:"Units",
        selector: (row: MeterDataRow) => row.units,
        sortable: false,
    },
    // {
    //     name: "Delete",
    //     selector: (row: MeterDataRow) => delete_button(row.uuid),
    //     sortable:false,
    //     maxWidth: '150px',
    //     omit: !hasPermission(['canDeleteIntervalData'])
    // }
    ]

    const handlePageChange = (page:number) => {
        url.searchParams.set('page',(page.toString()))
        handleFilterData()        
    }

    const handlePerRowsChange = (size:number) => {
        url.searchParams.set('page_size',(size.toString()))
        handleFilterData()        
    }

    
    const customStyles = {
    contextMenu: {
        style: {
        backgroundColor: '#1e1e1e', // your color
        color: '#fff',
        },
    },
    };



    const headers = [
        { label: "Date", key: "date" },
        { label: "Hour", key: "hour" },
        { label: "Value", key: "value" },
        { label: "Adjusted Value", key: "adjusted_value" },
        { label: "Units", key: "units" },
      ];

    
    const title = <div>
        <h2>Model Data </h2>
        <IonRow className="ion-justify-content-end">
            <IonButton size='small' >
                <CSVLink className='btn' style={{color:'white'}} data={tableData || []} headers={headers} separator=',' filename={`${meter?.name}_model_interval_data`}>
                    Download CSV
                </CSVLink>
            </IonButton>
        </IonRow>                    
                      
    </div>

    const context = <IonRow className="ion-justify-content-between" hidden={selected.length === 0} style={{fontSize:'26px',width:'100%'}}>
            <div style={{display:'flex',alignItems:'center'}} > {selected.length} Selected</div>
            <IonButton  fill='clear'>
                <ConfirmDeleteBtnModal id={'all'} handleDelete={handleDelete} icon={false} buttonText="Delete All">
                    This will delete all data and cannot be undone. Are you Sure?
                </ConfirmDeleteBtnModal>

                <ConfirmDeleteBtnModal id={selected} handleDelete={handleDelete}/>
            </IonButton>
        </IonRow>      

    return <DataTable
              title={title}
              columns={columns}
              data={tableData || []}              
              pagination
              paginationServer
              paginationTotalRows={count}
              paginationPerPage={100}
              paginationRowsPerPageOptions={[100, 200, 500, 1000,10000]}
              onChangeRowsPerPage={handlePerRowsChange} 
              onChangePage={handlePageChange}
              theme='dark'
              selectableRows={hasPermission(['canDeleteIntervalData'])}
              onSelectedRowsChange={handleSelect}            
              contextComponent={context}
              customStyles={customStyles}
              clearSelectedRows={clearRows}
            //   noContextMenu

    
            />    
};

export default ModelIntervalDataTable;